// lib/proto/codec.ts
// Codec that directly uses ts-proto generated types
import { InstrumentList } from '@/types/generated/common/types'
import {
  ClientMessage,
  CompressedPayload_CompressionMethod,
  Pong,
  ServerMessage,
} from '@/types/generated/public_api'

// ============================================
// Decoding (Bytes → Server)
// ============================================

export function decodeServerMessage(buffer: ArrayBuffer | Uint8Array): ServerMessage {
  const bytes = buffer instanceof ArrayBuffer ? new Uint8Array(buffer) : buffer
  return ServerMessage.decode(bytes)
}

export function extractError(msg: ServerMessage): any | null {
  return msg.error ?? null
}

/**
 * Wrap encoded protobuf bytes for a server-side `fetch` body.
 *
 * Node's fetch detaches the ArrayBuffer behind a BufferSource body and then
 * re-reads it, so passing a `Uint8Array`/`Buffer`/`ArrayBuffer` from a route
 * handler or server component fails with `TypeError: fetch failed` /
 * "Cannot perform ArrayBuffer.prototype.slice on a detached ArrayBuffer"
 * (reproduced on Node 25 + Next 15.5). A `Blob` owns its own copy and is
 * unaffected. Browser-side requests go through axios and are not affected.
 */
export function toFetchBody(bytes: Uint8Array): Blob {
  return new Blob([bytes as unknown as BlobPart], { type: 'application/octet-stream' })
}

export function encodePong(timestamp: string): Uint8Array {
  const pong: Pong = { timestamp: timestamp.toString() }
  return ClientMessage.encode({ pong }).finish()
}

export function encodeAuthMessage(token: string): Uint8Array {
  return ClientMessage.encode(ClientMessage.create({ authenticate: { token } })).finish()
}

export async function decompressServerMessage(serverMsg: ServerMessage) {
  if (serverMsg.compressedPayload) {
    const { data, method } = serverMsg.compressedPayload
    const decompressedBytes = await decompressBlob(
      data,
      method === CompressedPayload_CompressionMethod.COMPRESSION_METHOD_GZIP ? 'gzip' : 'deflate'
    )
    const instrumentList = InstrumentList.decode(decompressedBytes)

    return instrumentList
  }
}

export async function decompressBlob(compressedBytes: Uint8Array, method: 'gzip' | 'deflate') {
  const safeBytes = new Uint8Array(compressedBytes)

  const stream = new Response(new Blob([safeBytes])).body
  if (!stream) {
    throw new Error('Failed to create stream')
  }

  const decompressedStream = stream.pipeThrough(new DecompressionStream(method))

  const resultBuffer = await new Response(decompressedStream).arrayBuffer()
  return new Uint8Array(resultBuffer)
}
